import { useState, useEffect } from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';

import MESSAGES from 'constants/messages';

import { actions as authActions } from 'modules/auth';

const DowntimeWithTimer = ({ logout }) => {
    const initialSeconds = 60;
    const initialMinute = 0;
    const [minutes, setMinutes] = useState(initialMinute);
    const [seconds, setSeconds] = useState(initialSeconds);
    useEffect(() => {
        setTimeout(() => {
            logout({ goto: '/public/maintenance' });
        }, 1000 * initialSeconds);
    }, [logout]);

    useEffect(() => {
        const myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(myInterval);
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000);
        return () => {
            clearInterval(myInterval);
        };
    }, [logout, minutes, seconds]);
    return `${MESSAGES.DOWNTIME.TERMINAL_PHASE.DESCRIPTION} ${seconds} seconds.`;
};

DowntimeWithTimer.propTypes = {
    logout: func.isRequired,
};

const mapDispatchToProps = {
    logout: authActions.logout,
};

export default connect(null, mapDispatchToProps)(DowntimeWithTimer);
